$('.is-variant-swiper').each((index, swiperVariant) => {
    let select = $(swiperVariant).find('select.product-variant-selection');
    console.log($(swiperVariant).find('.swiper-slide'));

    $(swiperVariant).find('.swiper-slide img').on('click', (e) => {
        select.find('option:selected').attr('value', e.target.dataset.value);

        select.trigger('change');
    });
})
